import api from "./api";

/**
 * Prim & Maaş uçları (backend: /api/payroll). Yanıtlar ApiResponse zarfında
 * (res.data.data). Tüm uçlar MANAGER'a özeldir; kendi salonuna kapsanır.
 */
export const payrollService = {
  // Maaş
  listSalaries: () => api.get("/payroll/salaries"),
  upsertSalary: (staffId, payload) => api.put(`/payroll/salaries/${staffId}`, payload),

  // Avans
  listAdvances: (month) => api.get("/payroll/advances", { params: { month } }),
  createAdvance: (payload) => api.post("/payroll/advances", payload),
  deleteAdvance: (id) => api.delete(`/payroll/advances/${id}`),

  // İzin (backend: /api/staff/leaves). Sadece kayıt; bordroyu etkilemez.
  listLeaves: (month) => api.get("/staff/leaves", { params: { month } }),
  createLeave: (payload) => api.post("/staff/leaves", payload),
  deleteLeave: (id) => api.delete(`/staff/leaves/${id}`),

  // Bordro
  preview: (month) => api.get("/payroll/preview", { params: { month } }),
  list: (month) => api.get("/payroll", { params: { month } }),
  run: (month, finalize = false) => api.post("/payroll/run", null, { params: { month, finalize } }),
  adjust: (id, payload) => api.patch(`/payroll/${id}/adjustment`, payload),
};
